import styled from "styled-components";
import { colors } from "constants/colors";
import { BasicSectionContainer } from "../../style";
import {
  bookingStepContainerStyles,
  bookingStepContentStyles,
} from '../../bookingStepStyles';
import { sectionBackgroundStyles } from 'screens/sectionBackgroundStyles';
import { styleSizes } from "constants/styleSizes";

export const CheckOutContentContainer = styled(BasicSectionContainer)`
  ${bookingStepContainerStyles}

  .tabletTitle {
    width: 100%;
    font-size: 32px;
    font-weight: 600;
    line-height: 40px;
    color: ${colors.almostBlack};
    margin-top: 48px;
    margin-bottom: 16px;
  }

  .tabletSubTitle {
    margin-top: 8px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: ${colors.almostBlack};
  }

  .termsOfService {
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      padding-top:0;
    }
  }
  .topBookingMessage {
    display: flex;
    flex-direction: row;
  }

  .noWindow {
    color: ${colors.almostBlack};
    font-size: 16px;
    font-weight: 600;
    border: 1px solid ${colors.noWindow};
    padding: 16px;
    margin-top: 64px;
    margin-bottom: -32px;
    width: fit-content;
    display: flex;
    flex-direction: row;
    gap: 16px;
    /* flex-basis: calc(60% + 14px); */
    line-height: 26px;
    .noWindowText {
      flex: 1;
    }
    .noWindowIcon {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      margin-top: 32px;
      margin-bottom: 0;
    }

    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: 700;
      line-height: 26px;
    }
  }

  .background {
    ${sectionBackgroundStyles}
  }

  .content {
    column-gap: 32px;
    ${bookingStepContentStyles}
  }
  

  .spinner {
    position: absolute;
    top: calc(50% - 60px);
    left: calc(50% - 60px);
    width: 120px;
    height: 120px;
    z-index: 3000;
    background-color: ${colors.black};
  }

  @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
    .background {
      display: none;
    }
  }

  @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
  .content {
    flex-direction: column;
  }
}
`;

export const PaymentSectionContainer = styled(BasicSectionContainer)`
  flex-basis: 60%;
  max-width: 800px;
  min-width: 315px;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: start;
  justify-content: flex-start;
  margin-top: 64px;


  .confirmSection {
    margin-bottom: 112px;

    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
    margin-bottom: 64px;
  }
  
  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    margin-top: 0;
    margin-bottom: 16px;
  }
}

.confirmButtonWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
}

.paymentSectionTitle {
  margin: 32px 0 12px;
}

.sectionDescription {
  width: 100%;
  margin: 0 0 20px;
  font-size: 16px;
  color: ${colors.almostBlack};
}

.addressRow,
.cardDetailsRow {
  display: flex;
  gap: 16px;
  width: 100%;

  > * {
    flex: 1 1 0;
    min-width: 0;
  }
}

.cardNumberBox > * {
  width: 100%;
}

.paymentFormInput {
  width: 100%;
  /* оставь здесь существующие margin-bottom и media query */
}

@media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
  .addressRow {
    flex-direction: column;
    gap: 0;
  }
}

  @media only screen and (max-width: ${styleSizes.wideScreenBreakpoint}) {
    width: 100%;
    max-width: 100%;
  }

  @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
    margin-top: 48px;
  }

  .ratePlanTitle,
  .paymentDetailsTitle,
  .personalInfoTitle
   {
    font-size: 32px;
    font-weight: 600;

    color: ${colors.almostBlack};


    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      font-size: 24px;
      font-weight: 600;
    }
  }

  .paymentDetailsTitle {
    padding: 16px 0 8px 0;
  }
  .personalInfoTitle {
    padding: 48px 0 8px 0;
  }

  .paymentFormInput {
    width: 100%;
    margin-bottom: 24px;
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      margin-bottom: 24px;
    }
  }

  .cardNumberBox {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    
    .creditCardInput {
      flex: 6;
      .warning {
        line-height: 14px;
      }
    }
    .cvvInput {
      flex: 1;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        flex: 1;
      }
    }
    .expireDateInput {
      flex: 1;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        flex: 1;
      }
    }
    .cvvExpiryBox {
      flex: 4;
      display: flex;
      gap: 16px;
      flex-direction: row;
      @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      flex-direction: column;
      gap: 0;
    }
    }
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      flex-direction: column;
      gap: 0;
    }
  }

  .emailPhoneBox {
    display: flex;
    flex-direction: row;
    flex: 1;
    width: 100%;
    gap: 16px;
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      flex-direction: column;
      gap: 0;
    }
  }
`;

export const PlanSectionContainer = styled(BasicSectionContainer)`
  min-height: 135px;
  max-height: 254px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 5px 0 5px 0;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
    min-height: auto;

    max-height: fit-content;
    }

  .choosePlanText {
    line-height: 23px;
    margin-top: 8px;
    font-size: 16px;
  }
  .ratePlanTitle,
  .paymentDetailsTitle {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 32px;
    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      font-size: 24px;
      font-weight: 600;
    }

  }

  
  .ratePlanTitle {
    margin-bottom: 42px;
  }

  .selectionContainer {
    flex: 8;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
      flex-direction: column;
      gap: 32px;
    }
  }

  .priceInText {
    color: ${colors.optionBackground};
    font-weight: 600;
  }

  .planRadio {
    margin: 0 10px 0 0;
  }

  /* @media only screen and (min-width: 767px) and (max-width: 1200px) {
    height: auto;

    .selectionContainer {
      flex: 1;
      width: 100%;
      height: auto;
      flex-direction: column;

      .sectionContainerItem {
        max-width: 83%;
        margin-right: 0;
      }

      p {
        font-size: 12px;
        padding: 0 0 0 40px;
      }

      .title {
        font-size: 14px;
      }
    }
  } */

  /* @media only screen and (max-width: 767px) {
    display: none;
  } */
`;

export const SectionContainerItem = styled.div<{ selected?: boolean }>`
  max-width: 511px;

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin-right: 30px;
  cursor: pointer;

  .inputContainer {
    display: flex;

    .title {
      font-size: 16px;
      font-weight: 600;
    }
  }

  p {
    width: 100%;
    font-size: 16px;

    color: ${colors.menuGrey};
  }
`;

export const PaymentInfoContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
  box-sizing: border-box;
  margin: 0;

  .row {
    position: relative;
    width: 100%;
    display: flex;
    column-gap: 16px;

    .emailInput {
      width: 65%;
    }

    .phoneNumberInput {
      width: 35%;
      .warning {
        // Update component CSS with styles that we have for other fields
        // Not a best implementation, but shold works..
        width: 100%;
        height: 20px;
        line-height: 20px;
        position: absolute;
        color: ${colors.red};
        font-size: 14px;
        font-weight: 400;
        white-space: normal;
        overflow: visible;
        text-overflow: unset;
        text-align: left;
        margin-top: 5px;
      }
    }
  }

  .infoInputField {
    width: 100%;
    margin-bottom: 20px;

    label {
      display: block;
      font-size: 12px;
      color: ${colors.menuGrey};
      margin-bottom: 5px;
      letter-spacing: 1px;
    }
  }

  @media only screen and (max-width: ${styleSizes.wideScreenBreakpoint}) {
    min-width: 100%;

    .row {
      flex-direction: column;

      .emailInput {
        width: 100%;
      }

      .phoneNumberInput {
        width: 60%;
      }
    }
  }

  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    margin: 0;

    .row {
      .phoneNumberInput {
        width: 60%;
      }
    }
  }
`;

export const SignInModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: ${colors.white};
  border-radius: 32px;
  z-index: 200;
  width: 90%;
  max-width: 348px;
  min-height: 365px;

  .closeButton {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .largeTitle {
    width: 90%;
    font-size: 33px;
    font-weight: bold;
    text-align: center;
    line-height: normal;
    margin: 30px 0 20px 0;
  }

  .input {
    width: 80%;
    margin: 14px 0px;
  }

  .buttonContainer {
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 15px 0 30px 0;
  }

  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    .largeTitle {
      font-size: 32px;
    }

    .input {
      width: 90%;
    }
  }
`;

// export const BookingSummaryContainer = styled.div`
//   flex-basis: 40%;
//   min-width: 400px;
//   margin: 103px 0 0 0;

// /** Have to be moved to common styles in future - begin */

// .datesTable {
//     margin-top: 32px;
//     width: 100%;
//     .hdr {
//       white-space: nowrap;
//       padding-bottom: 15px;
//       font-weight: 600;
//       font-size: 16px;
//     }
//     .data {
//       font-size: 16px;
//     }
//     .dataRt {
//       text-align: right;
//     }
//   }
//   .breakdownTable {
//   padding-top: 10px;
//   font-size: 16px;
//   width: 100%;

//   td {
//     padding-bottom: 15px;
//   }

//   .line {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     white-space: nowrap;
//   }

//   .label {
//     padding-right: 10px;
//   }

//   .dots {
//     flex-grow: 1;
//     border-bottom: 1px dotted #aaa;
//     margin: 0 10px;
//     height: 1px;
//     transform: translateY(-1px);
//   }
//   .price {
//     text-align: right;
//     white-space: nowrap;
//   }

//   .total {
//     font-weight: bold;
//   }
// }

// /** Have to be moved to common styles in future - end */
// .booking {
//     font-size: 18px;
//     margin: 38px 0 24px 0;
//     font-weight: 600;
//   }

//   .card {
//     /* width: 100%;
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//     justify-content: space-between;
//     align-items: flex-start;
//     padding: 20px;
//     margin: 0; */

//     .title {
//       font-size: 24px;
//     margin: 10px 0px 30px;
//     display: flex
// ;
//     -webkit-box-pack: justify;
//     justify-content: space-between;
//     -webkit-box-align: center;
//     align-items: center;
//     font-weight: 600;
//     .text {
//       font-size: 24px;
//       font-weight: 600;

//     }
//     }

//     .row {
//       width: 100%;
//       display: flex;
//       justify-content: space-between;
//       column-gap: 20px;
//     }

//     .warning {
//       color: ${colors.red};
//       font-size: 16px;
//       font-weight: 600;
//     }

//     .tooltipContent {
//       svg {
//         margin: 0 0 0 5px;
//       }

//       .highLight{
//         font-size: 14px;
//         font-weight: 600;
//         font-style: italic;
//         color: ${colors.tooltip};
//       }

//       .text {
//         font-size: 24px;
//         font-weight: 600;
//       }
//     }

//     /* .infoRow.dates {
//       width: 60%;
//     }

//     .infoRow.quantity {
//       width: 40%;
//     }

//     .infoRow {
//       width: 100%;
//       margin: 5px 0 20px 0;

//       .infoLabel {
//         font-size: 16px;
//         font-weight: 600;
//         color: ${colors.black};
//         text-align: left;
//         margin: 0 0 5px 0;
//       }

//       .infoValue {
//         font-size: 16px;
//         color: ${colors.userSelectionBlack};
//         text-align: left;
//       }
//     } */

//     .breakDown {
//       width: 100%;
//       margin: 0 0 12px 0;

//       .breakDownTitle {
//         font-size: 14px;
//         font-weight: 600;
//         color: ${colors.black};
//         text-align: left;
//         margin: 0 0 5px 0;
//       }

//       .breakDownRow {
//         width: 100%;
//         display: flex;
//         justify-content: space-between;
//         align-items: flex-end;
//         font-size: 16px;
//         color: ${colors.userSelectionBlack};
//         margin-bottom: 8px;

//         .breakDownLabel {
//           text-align: left;
//           width: 70%;

//           svg {
//             position: relative;
//             top: 6px;
//             left: 5px;
//           }
//         }

//         .breakDownValue {
//           text-align: right;
//           width: 30%;
//         }
//       }
//     }

//     .totalRow {
//       width: 100%;
//       display: flex;
//       flex-direction: row;
//       justify-content: space-between;
//       align-items: center;
//       margin: 0 0 20px 0;

//       .totalLabel {
//         text-align: left;
//         width: 70%;
//         font-size: 14px;
//         font-weight: 600;
//         color: ${colors.black};
//       }

//       .totalValue {
//         text-align: right;
//         width: 30%;
//         font-size: 18px;
//         font-weight: bold;
//         color: ${colors.black};
//       }
//     }
//     .checkOutButton {
//         align-self: flex-end;
//       }

//     .termsOfServiceContainer {
//       width: 100%;
//       padding: 10px 8px;
//       margin: 20px 0;

//       .required {
//         margin-top: 8px;
//         color: ${colors.red};
//         font-size: 16px;
//       }

//       .termsOfService {
//         display: flex;

//         .text{
//           margin-left: 5px;

//           .plainText {
//             font-size: 16px;
//             height: 30px;
//             line-height: 24px;
//             color: ${colors.black};
//             cursor: pointer;
//           }

//           .highLight {
//             font-size: 16px;
//             height: 30px;
//             line-height: 24px;
//             font-weight: 400;
//             color: ${colors.hoverBlue};
//             white-space: nowrap;
//             cursor: pointer;
//             text-decoration: underline;
//           }
//         }

//       }
//     }
//   }

//   .couponContainer {
//     width: 100%;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 20px;
//     column-gap: 10px;

//     label {
//       color: ${colors.black};
//     }

//     .applyCouponButton {
//       margin: 5px 0 0 0;
//     }
//   }

//   @media only screen and (max-width: 767px) {
//     display: none;
//   }
// `;

export const MobileBookingSummaryContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 15px;
  margin: 0;

  .title {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .bookingDates {
    width: 100%;
  }

  .guestOption,
  .roomOption {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    padding: 5px 0;
    border-bottom: 1px solid ${colors.checkOutTableTextColor};

    .text {
      .optionTitle {
        font-size: 14px;
        font-weight: 600;
        color: ${colors.black};
      }

      .optionDescription {
        font-size: 16px;
        font-style: italic;
        color: ${colors.noBookingText};
      }
    }

    .optionButtons {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .quantity {
        text-align: center;
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 21px;
        font-weight: 600;
      }
    }

    .disabled {
      g,
      line {
        stroke: ${colors.signInBorderColor};
      }
    }
  }

  .addOnOption {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    padding: 5px 0;
    border-bottom: 1px solid ${colors.checkOutTableTextColor};

    .text {
      font-size: 14px;
      font-weight: 600;
      color: ${colors.black};
    }

    .remove {
      cursor: pointer;
      margin: 0 8px 0 0;

      .removeIcon {
        margin-left: 5px;
        height: 10px;
        width: 10px;
      }
    }
  }

  .row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    column-gap: 20px;
  }

  .warning {
    color: ${colors.red};
    font-size: 14px;
    font-weight: 600;
  }

  .infoRow.dates {
    width: 60%;
  }

  .infoRow.quantity {
    width: 40%;
  }

  .infoRow {
    width: 100%;
    margin: 5px 0 20px 0;

    .infoLabel {
      font-size: 14px;
      font-weight: 600;
      color: ${colors.black};
      text-align: left;
      margin: 0 0 5px 0;
    }

    .infoValue {
      font-size: 16px;
      color: ${colors.menuGrey};
      text-align: left;
    }
  }

  .breakDown {
    width: 100%;
    margin: 10px 0 12px 0;

    .breakDownTitle {
      font-size: 14px;
      font-weight: 600;
      color: ${colors.black};
      text-align: left;
      margin: 0 0 5px 0;
    }

    .breakDownRow {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      font-size: 16px;
      color: ${colors.menuGrey};
      margin-bottom: 8px;

      .breakDownLabel {
        text-align: left;
        width: 80%;

        svg {
          position: relative;
          top: 6px;
          left: 5px;
        }
      }

      .breakDownValue {
        text-align: right;
        width: 30%;
      }
    }
  }

  .totalRow {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 20px 0;

    .totalLabel {
      text-align: left;
      width: 70%;
      font-size: 14px;
      font-weight: 600;
      color: ${colors.black};
    }

    .totalValue {
      text-align: right;
      width: 30%;
      font-size: 18px;
      font-weight: bold;
      color: ${colors.black};
    }
  }

  .termsOfService {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 2px solid ${colors.questionBorder};
    padding: 15px 20px;
    margin: 15px 0;

    .text {
      margin-left: 5px;

      .plainText {
        font-size: 16px;
        height: 30px;
        line-height: 30px;
        color: ${colors.black};
        cursor: pointer;
      }

      .highLight {
        font-size: 16px;
        height: 30px;
        line-height: 30px;
        font-weight: bold;
        color: ${colors.hoverBlue};
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }

  /* .couponContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    column-gap: 10px;

    label {
      color: ${colors.black};
    }

    .applyCouponButton {
      margin: 5px 0 0 0;
    }
  } */

  @media only screen and (min-width: ${styleSizes.miniBreakpoint}) {
    display: none;
  }
`;

export const RatePlanContainer = styled.div`
  width: 100%;
  padding: 0 0 5px 0;
  border-bottom: 1px solid ${colors.checkOutTableTextColor};
  margin: 10px 0;

  .infoLabel {
    font-size: 14px;
    font-weight: 600;
    color: ${colors.black};
    text-align: left;
    margin: 0 0 5px 0;
  }

  .infoValue {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: ${colors.black};

    svg {
      cursor: pointer;
    }
  }
`;
